import Flex from 'components/Flex'
import React from 'react'

import Button from 'components/Button/index'

import Checkbox from 'components/Form/Checkbox'
import Input from 'components/Form/Input'
import InputNumber from 'components/Form/InputNumber'
import RadioButton from 'components/Form/RadioButton'
import Slider from 'components/Form/Slider'
import Switch from 'components/Form/Switch'
import TextArea from 'components/Form/TextArea'

import Drawer from 'components/Drawer/index'

const Students = () => {
  return (
    <Flex column>
      Students Module
      <Flex>
        <Button.Primary text={'primary button'} />
        <Button.Secondary text={'Secondary button'} />
        <Button.Danger text={'Danger'} />
        <Button.Default text={'default'} />
        <Button.Round icon={'R'} />
        <Button.Circle icon={'C'} />
      </Flex>
      <Flex column>
        <Checkbox />
        <InputNumber />
        <Input />
        <RadioButton />
        <Slider />
        <Switch />
        <TextArea />
      </Flex>
      <Drawer
        title={'Drawer Title'}
        placement={'right'}
        visible={false}
        content={'DRawer Content'}
        footer={'footer'}
        onClose={true}
      />
    </Flex>
  )
}
export default Students
